<div class="ph-tabs">
  <ul class="ph-tabs__nav">
    <li
      class="ph-tabs__nav-item"
      *ngFor="let tab of tabs"
      (click)="selectTab(tab)"
      [hidden]="tab.hideTab"
      [class.active]="tab.active"
    >
      {{ tab.title }} {{ tab.number ? '(' + tab.number + ')' : '' }}
    </li>
  </ul>
  <ng-content></ng-content>
</div>
